import { VectorCoreValue } from '@/assets';
import React, { useState } from 'react';
import Marquee from 'react-fast-marquee';
import { useTranslation } from 'react-i18next';

const SectionCoreValue = () => {
  const { t } = useTranslation();
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const [mousePos, setMousePos] = useState<{ x: number; y: number }>({ x: 0, y: 0 });

  // Handler mouse move
  const handleMouseMove = (e: React.MouseEvent, i: number) => {
    const rect = (e.target as HTMLElement).getBoundingClientRect();
    setHoveredIndex(i);
    setMousePos({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    });
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null);
  };
  const coreValues = [
    {
      number: '01',
      title: t('Innovation'),
      desc: t('Creating new value through continuous challenges and creative thinking'),
    },
    {
      number: '02',
      title: t('Expertise'),
      desc: t(
        'Providing solutions based on deep technical knowledge and understanding of the industry'
      ),
    },
    {
      number: '03',
      title: t('Trust'),
      desc: t('Building solid partnerships by keeping promises and communicating transparently'),
    },
    {
      number: '04',
      title: t('Quality'),
      desc: t('Providing the best results through uncompromising quality management'),
    },
    {
      number: '05',
      title: t('Collaboration'),
      desc: t('Creating synergy through teamwork and open communication'),
    },
  ];
  return (
    <div className="section-core-value">
      <Marquee direction="right" style={{ marginTop: '48px' }}>
        {[...Array(3)].map((_, i) => (
          <div
            className="marquee-item"
            key={i}
            onMouseMove={(e) => handleMouseMove(e, i)}
            onMouseLeave={handleMouseLeave}
            style={
              hoveredIndex === i
                ? ({
                    '--x': `${mousePos.x}px`,
                    '--y': `${mousePos.y}px`,
                  } as React.CSSProperties)
                : undefined
            }
          >
            <VectorCoreValue className={`icon-vector${hoveredIndex === i ? ' highlight' : ''}`} />
            <span className={`text-marquee text-purple${hoveredIndex === i ? ' highlight' : ''}`}>
              {t('Core Value')}
            </span>
          </div>
        ))}
      </Marquee>
      <Marquee direction="left" style={{ marginTop: '20px' }}>
        {[...Array(3)].map((_, i) => (
          <div
            className="marquee-item"
            key={i}
            onMouseMove={(e) => handleMouseMove(e, i)}
            onMouseLeave={handleMouseLeave}
            style={
              hoveredIndex === i
                ? ({
                    '--x': `${mousePos.x}px`,
                    '--y': `${mousePos.y}px`,
                  } as React.CSSProperties)
                : undefined
            }
          >
            <VectorCoreValue className={`icon-vector${hoveredIndex === i ? ' highlight' : ''}`} />
            <span className={`text-marquee text-purple${hoveredIndex === i ? ' highlight' : ''}`}>
              {t('Core Value')}
            </span>
          </div>
        ))}
      </Marquee>
      <div className="core-value">
        <div className="core-value__left">
          <p>[{t('Core Value')}]</p>
        </div>
        <div className="core-value__right">
          {coreValues.map((item) => (
            <div className="grid-row">
              <div className="card-item">
                <p className="number">[{item.number}]</p>
                <div className="info">
                  <p className="title">{item.title}</p>
                  <p className="desc">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default React.memo(SectionCoreValue);
